<template>
  <div class="chanel-logo-wrapper">
    <Picture
      image-url="https://slimages.macysassets.com/is/image/MacysInc/2024_chanel_brand_shop_banner_dkt_mcy"
      alt="Chanel Authorized Retailer"
      image-intrinsic-width="1440"
      aspect-ratio="7/1"
    />
  </div>
</template>

<script setup>
import Picture from '@atomic-ui/picture/Picture';
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
:deep(.picture-image) {
  min-height: 200px;
  object-fit: cover;
  object-position: center;
}

.chanel-logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
